import { ComponentPropsWithRef, FC, PropsWithChildren } from 'react';
import { Text } from '@components/Text/Text.component';
import { TextPropsOptionalVariant } from '@components/Text/Text.types';
import classnames from 'classnames';

const PlcHeaderCell: FC<
  PropsWithChildren<ComponentPropsWithRef<'th'> & { header?: boolean; textProps?: TextPropsOptionalVariant }>
> = ({ className, children, header, textProps = {}, ...rest }) => {
  const rootClass = classnames('plc-table-cell-header', className);
  const {
    variant = header ? 'tiny-title' : 'h6',
    flavour = header ? 'grey' : 'dark',
    tag = 'div',
    ...restTextProps
  } = textProps;
  return (
    <th className={rootClass} {...rest}>
      <Text flavour={flavour} tag={tag} variant={variant} {...restTextProps}>
        {children}
      </Text>
    </th>
  );
};

export { PlcHeaderCell };
